import { Link, Typography } from '@mui/material';
import { BILLING_AUTHORIZATION } from '../config';

const handleLinkClick = (e: React.MouseEvent) => e.stopPropagation();

export const BillingAuthorizationLabel = () => (
  <Typography variant="body2">
    {BILLING_AUTHORIZATION.TEXT}{' '}
    <Link
      href={BILLING_AUTHORIZATION.SAAS_AGREEMENT_HREF}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleLinkClick}
    >
      {BILLING_AUTHORIZATION.SAAS_AGREEMENT_LINK_TEXT}
    </Link>
    {' and '}
    <Link
      href={BILLING_AUTHORIZATION.PRIVACY_POLICY_HREF}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleLinkClick}
    >
      {BILLING_AUTHORIZATION.PRIVACY_POLICY_LINK_TEXT}
    </Link>
  </Typography>
);
